
export default {
  mounted () {
    // this.$websocket() // Added NotificationSubscriber instead
  }
}
